var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLaptopSimple = function SvgLaptopSimple(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 15,
    "data-width-24": 22,
    viewBox: "0 0 14.8 11.1",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M12.908 10.446H1.83A1.23 1.23 0 0 1 .6 9.216V7.985h4.307l.615.615h3.692l.616-.615h4.308v1.23a1.23 1.23 0 0 1-1.231 1.231"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M2.446 7.985a1.23 1.23 0 0 1-1.23-1.231V1.83A1.23 1.23 0 0 1 2.446.6h9.847a1.23 1.23 0 0 1 1.23 1.23v4.923a1.23 1.23 0 0 1-1.23 1.23"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLaptopSimple);
export default ForwardRef;